// Shared inline SVG gradient defs (cvgrad, tg) — referenced by stroke="url(#tg)"
// across pages. Rendered once at the App root.
export const GradientDefs = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true">
    <defs>
      <linearGradient id="cvgrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#2FD3C6" />
        <stop offset=".34" stopColor="#3B93F2" />
        <stop offset=".66" stopColor="#8B5CF6" />
        <stop offset="1" stopColor="#EC4899" />
      </linearGradient>
      <linearGradient id="tg" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#2FD3C6" />
        <stop offset=".5" stopColor="#8B5CF6" />
        <stop offset="1" stopColor="#EC4899" />
      </linearGradient>
    </defs>
  </svg>
);
